"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewalCardDetailsPanelWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var PanelDashed_1 = require("../../components/PanelDashed");
var components_1 = require("@athena-portal/components");
var RenewalCardDetailsPanelWidget = /** @class */ (function (_super) {
    __extends(RenewalCardDetailsPanelWidget, _super);
    function RenewalCardDetailsPanelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.renderCardInformation = function () {
            var card = _this.findMainPaymentCard();
            if (card) {
                return ((0, jsx_runtime_1.jsx)("div", { className: "d-flex justify-content-center mt-3", children: (0, jsx_runtime_1.jsxs)("div", { className: "card-details-wrapper", children: [(0, jsx_runtime_1.jsx)("span", { className: "pr-2", children: _this.renderCardImage(card) }), "\u00A0", (0, jsx_runtime_1.jsx)("span", { children: _this.renderCardTypeName(card) }), "\u00A0", (0, jsx_runtime_1.jsxs)("span", { children: ["ending in ", (0, jsx_runtime_1.jsx)("b", { children: card.number.split('******')[1] })] })] }) }));
            }
            else {
                return null;
            }
        };
        _this.navigateToChangePaymentDetails = function () {
            var changePaymentDetailsPage = _this.getSetting("changePaymentDetailsPage");
            if (changePaymentDetailsPage) {
                _this.props.engine.navigate(changePaymentDetailsPage, false);
            }
        };
        _this.state = {};
        return _this;
    }
    RenewalCardDetailsPanelWidget.prototype.render = function () {
        var interaction = this.props.interaction;
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: interaction.factors.premiumType === 'annual' && this.renderPaymentContent() }));
    };
    RenewalCardDetailsPanelWidget.prototype.renderPaymentContent = function () {
        return ((0, jsx_runtime_1.jsx)(PanelDashed_1.PanelDashed, { className: "bg-white text-center pay-by-card-panel", children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "panel-dashed-contents card-information", children: this.renderCardInformation() }), (0, jsx_runtime_1.jsx)("div", { className: "pb-2 or-divider", children: " OR" }), (0, jsx_runtime_1.jsx)("div", { className: "simple-link no-outline use-different-cart-link", id: "changeCard", role: "link", "aria-label": "Use a different card to pay", onClick: this.navigateToChangePaymentDetails, tabIndex: 0, children: "Use a different card" })] }) }));
    };
    RenewalCardDetailsPanelWidget.prototype.renderCardImage = function (card) {
        if (card.type.includes("VISA")) {
            return (0, jsx_runtime_1.jsx)("img", { className: "payment-icon", alt: "Visa icon", src: "/img/visa-icon.svg" });
        }
        if (card.type.includes("MASTERCARD")) {
            return (0, jsx_runtime_1.jsx)("img", { className: "payment-icon", alt: "Mastercard icon", src: "/img/mastercard-icon.svg" });
        }
        return null;
    };
    ;
    RenewalCardDetailsPanelWidget.prototype.renderCardTypeName = function (card) {
        if (card.type.includes("VISA")) {
            return "Visa";
        }
        if (card.type.includes("MASTERCARD")) {
            return "Mastercard";
        }
        return "";
    };
    ;
    RenewalCardDetailsPanelWidget.prototype.findMainPaymentCard = function () {
        var interaction = this.props.interaction;
        if (interaction.agreeToReuseCardDetails && interaction.policyHolder.cardDetails) {
            return interaction.policyHolder.cardDetails[0];
        }
        return null;
    };
    RenewalCardDetailsPanelWidget = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], RenewalCardDetailsPanelWidget);
    return RenewalCardDetailsPanelWidget;
}(plugin_journey_1.WidgetBase));
exports.RenewalCardDetailsPanelWidget = RenewalCardDetailsPanelWidget;
//# sourceMappingURL=RenewalCardDetailsPanelWidget.js.map